<template>
  <div v-click-away="close" class="btn-extendable-container">
    <button
      class="btn-extendable"
      :class="{ 'btn-link': asLink, active: isActiveData }"
      @click="toggleList($event)"
    >
      <span>{{ trans(text) }}</span>
    </button>
    <ul
      ref="menu"
      :class="{ active: isActiveData }"
      class="btn-list-extendable"
    >
      <li
        v-for="(element, index) in list"
        :key="index"
        class="btn-list-extendable__item"
        @click="choose(element.state, $event)"
      >
        {{ element.trans }}
      </li>
    </ul>
  </div>
</template>

<script>
import { translationMixin } from '@elements/translation';
import { eventBus } from '@tools/event-bus';

export default {
  name: 'ExtendableButton',
  mixins: [ translationMixin ],
  props: {
    /**
     * Text displayed on the button
     */
    text: { type: String, default: () => { } },
    /**
     * List dropdown
     */
    list: { type: Array, default: () => {} },
    /**
     * Some unique identifier for the button
     * We need it, in order to be able to close all other when opening one
     */
    id: { type: String, default: () => {} },
    /**
     * Boolean to be able to open/close the dropdown from parent
     */
    isActiveProp: { type: Boolean, default: false },
    /**
     * Since We can toggle the dropdown also from this component
     * we need to tell parent the value of the boolean
     */
    onToggle: { type: Function, default: () => {} },
    /**
     * Advise parent which element we clicked on
     */
    onChoose: { type: Function, default: () => {} },
    /**
     * Displayed as a button or an inlined link
     */
    asLink: { type: Boolean, default: true },
  },
  data() {
    return {
      /**
       * We can't mutate prop in vueJS, bad pattern
       * We need a state to do so
       */
      isActiveData: this.isActiveProp,
    };
  },
  watch: {
    /**
     * When parent change this value
     */
    isActiveProp: {
      handler(newValue) {
        this.isActiveData = newValue;
      },
    },

  },
  methods: {
    async close() {
      if (this.isActiveData) {
        this.isActiveData = false;
        this.onToggle(false);
        await this.$nextTick();
        this.$refs.menu.classList.remove('stick-top');
      }
    },
    choose(element, event) {
      // stop propagation to avoid closing by the window listener
      if (event) {
        event.stopPropagation();
      }
      this.onChoose(element);
    },
    async toggleList(event) {
      // stop propagation to avoid closing by the window listener
      if (event) {
        event.stopPropagation();
      }
      // advize parent that we toggle the dropdown
      this.onToggle(!this.isActiveData);
      // actually toggle the dropdown
      this.isActiveData = !this.isActiveData;
      this.opened = !this.opened;
      await this.$nextTick();
      // On closing, advise all parents that we opened this particular dropdown
      // so parent can manually close all other
      if (this.isActiveData) {
        eventBus.dispatchEvent(new CustomEvent('extendable-button-opened', { detail: { id: this.id } }));
      }
    },
  },
};
</script>
